
import waitingForNewRiderImage from "~/assets/images/waitingForNewRiderImage.svg";
export default {
  props: {
    trackingLink: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      waitingForNewRiderImage
    };
  }
};
